module.exports = __webpack_public_path__ + "static/media/femec-logotip-black.248bdbcf.png";